export default () => ({
  remove__button: {
    textTransform: 'none',
  },
  delete__icon: {
    marginRight: '0.4rem',
  },
});
